module.exports = __webpack_public_path__ + "static/media/shibani-logoo.27bad4d4.png";